import React from "react";

import { TipButtonProps } from "@data-types/offer/event-row/TipButtonProps";
import { useOfferOptionsContext } from "@state/hooks/offer/useOfferOptionsContext";
import { observer } from "mobx-react";

import { OfferHistoryTipButton } from "./components/OfferHistoryTipButton";
import { PlayerTipButton } from "./components/PlayerTipButton";
import { RegularTipButton } from "./components/RegularTipButton";

export default observer(function TipButton(props: TipButtonProps) {
	const baseCssClass = `match${props.isGridItem ? "__grid" : ""}__item`;
	const OfferOptionContext = useOfferOptionsContext();
	const isLong =
		props.tip?.displayTip == null
			? false
			: props.tip.displayTip.length >= 4;

	if (props.isMargin) {
		return (
			<div className="offer--additional__item quote quote--margin">
				{props.margin}
			</div>
		);
	}

	if (props.isResult) {
		return (
			<div className="offer--additional__item quote quote--margin u-type--center">
				{props.result}
			</div>
		);
	}

	if (OfferOptionContext.isOfferHistory) {
		return <OfferHistoryTipButton {...props} />;
	}
	if (props.isPlayer) {
		return <PlayerTipButton tip={props.tip} isStats={props.isStats} />;
	}
	return (
		<RegularTipButton
			tip={props.tip}
			isLong={isLong}
			isGridItem={props.isGridItem}
			baseCssClass="offer--additional__item"
			hasPlaceHolders={props.hasPlaceHolders}
		/>
	);
});
